export const setPreviousGzCoin = (gzCoin: number) => {
  sessionStorage.setItem("previousGzCoin", JSON.stringify(gzCoin));
};

export const getPreviousGzCoin = (): number | null => {
  const previousGzCoin = sessionStorage.getItem("previousGzCoin");
  return previousGzCoin ? JSON.parse(previousGzCoin) : null;
};

export const clearPreviousGzCoin = () => {
  sessionStorage.removeItem("previousGzCoin");
};
